export const groupDestinationsByType = destinations => {
  return Object.values(destinations.reduce((accumulator, destination) => {
    if (accumulator[destination.type] == undefined) {
      accumulator[destination.type] = [];
    }
    accumulator[destination.type].push(destination);
    return accumulator;
  }, {}));
};